import React, {useEffect} from "react";

import './_alarm.scss'
import {Breadcrumb, BreadcrumbItem, Button, CodeSnippet, Column, Grid, Loading, Tile} from "@carbon/react";
import {Link, useParams} from "react-router-dom";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {grpcAlarmServiceSelector} from "../../state/grpc";
import {alarmState, errorState, loadingState} from "../../state/alarm_detail"
import parse from "html-react-parser";
import AlarmEventsTable from "../../components/AlarmsTable/AlarmEventsTable";
import {
  editAlarmNoteModalNotesState,
  editAlarmNoteModalOpenState,
  editAlarmPriorityModalOpenState,
  editAlarmPriorityModalPriorityState,
  forceCloseAlarmsModalIdsState,
  forceCloseAlarmsModalOpenState, forwardAlarmsState,
  forwardToSupportAlarmModalOpenState,
  reportToUserModalOpenState,
  selectedAlarmState,
} from "../../state/alerts_table";
import EditAlertNoteModal from "../../components/AlarmsTable/EditAlertNoteModal";
import EditAlertPriorityModal from "../../components/AlarmsTable/EditAlertPriorityModal";
import ForwardToSupportModal from "../../components/AlarmsTable/ForwardToSupportModal";
import BatchCloseModal from "../../components/AlarmsTable/BatchCloseModal";
import {ADD, useToastContext} from "../../components/Toast";
import ReportToUserModal from "../../components/AlarmsTable/ReportToUserModal";

const Alarm = () => {
  const {alarmID} = useParams()
  const [loading, setLoading] = useRecoilState(loadingState)
  const [error, setError] = useRecoilState(errorState)
  const [alarm, setAlarm] = useRecoilState(alarmState)

  const {toastDispatch} = useToastContext();

  const setSelectedAlarm = useSetRecoilState(selectedAlarmState)
  const setForwardAlarms = useSetRecoilState(forwardAlarmsState)
  const setEditAlarmNoteModalOpen = useSetRecoilState(editAlarmNoteModalOpenState)
  const setEditAlarmNoteModalNotes = useSetRecoilState(editAlarmNoteModalNotesState)
  const setEditAlarmPriorityModalPriority = useSetRecoilState(editAlarmPriorityModalPriorityState)
  const setEditAlarmPriorityModalOpen = useSetRecoilState(editAlarmPriorityModalOpenState)
  const setForceCloseAlarmsModalOpen = useSetRecoilState(forceCloseAlarmsModalOpenState)
  const setForceCloseAlarmsModalIdsState = useSetRecoilState(forceCloseAlarmsModalIdsState)
  const setForwardToSupportAlarmModalOpen = useSetRecoilState(forwardToSupportAlarmModalOpenState)
  const setReportToUserModalOpenState = useSetRecoilState(reportToUserModalOpenState)

  const alarmsService = useRecoilValue(grpcAlarmServiceSelector)

  const getAlarm = (alarmId) => {
    const req = new proto.api.GetAlarmRequest()
    req.setAlarmid(parseInt(alarmId))
    setLoading(true)
    alarmsService.getAlarm(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        setAlarm(resp.toObject().alarm)
      }
      setLoading(false)
    })
  }

  useEffect(() => {
    getAlarm(alarmID)
  }, [alarmID])

  if (loading) {
    return (
      <Loading withOverlay={true}/>
    )
  }

  if (error) {
    return (
      <Grid fullWidth className="alarm-page">
        <Column lg={16} md={8} sm={4}>
          <Grid className="page-banner">
            <Column lg={16} md={4} sm={4}>
              <Breadcrumb noTrailingSlash aria-label="Page navigation">
                <BreadcrumbItem>
                  <Link to='/'>Home</Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  Allarmi
                </BreadcrumbItem>
                <BreadcrumbItem>
                  {alarmID}
                </BreadcrumbItem>
              </Breadcrumb>
            </Column>
            <Column lg={16} md={4} sm={4}>
              <h1 className="page-heading">
                Allarme {alarmID}
              </h1>
            </Column>
          </Grid>
          <Grid>
            <Column lg={16} md={8} sm={4} className="alarm-page__r1">
              <Tile>
                <h4>Non è possibile visualizzare i dati di questo allarme. Riprovare più tardi</h4>
              </Tile>
            </Column>
          </Grid>
        </Column>
      </Grid>
    )
  }

  const handleTakeOwnership = (alarmId) => {
    const req = new proto.api.TakeOwnershipRequest()
    req.setAlarmid(alarmId)
    alarmsService.takeOwnership(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        toastDispatch({
          type: ADD,
          payload: {
            title: "Operazione fallita",
            content: "Non è stato possibile prendere in carico l'allarme",
            kind: "error",
            caption: err.message
          }
        })
      } else {
        updateAlarm()
        toastDispatch({
          type: ADD,
          payload: {
            title: "Operazione avvenuta con successo",
            content: "Allarme preso in carico",
            kind: "success"
          }
        })
      }
    })
  }

  const updateAlarm = () => {
    getAlarm(alarmID)
  }

  return (
    <>
      <EditAlertNoteModal onAlarmNotesSaved={(id, notes) => updateAlarm()}/>
      <EditAlertPriorityModal onAlarmPriorityUpdated={(id, priority) => updateAlarm()}/>
      <ForwardToSupportModal onAlarmForwarded={(id) => updateAlarm()}/>
      <BatchCloseModal onAlarmsClosed={() => {}}/>
      <ReportToUserModal />
      <Grid fullWidth className="alarm-page">
        <Column lg={16} md={8} sm={4}>
          <Grid className="page-banner">
            <Column lg={16} md={4} sm={4}>
              <Breadcrumb noTrailingSlash aria-label="Page navigation">
                <BreadcrumbItem>
                  <Link to='/'>Home</Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  Allarmi
                </BreadcrumbItem>
                <BreadcrumbItem>
                  {alarmID}
                </BreadcrumbItem>
              </Breadcrumb>
            </Column>
            <Column lg={16} md={4} sm={4}>
              <h1 className="page-heading">
                Allarme {alarmID}
              </h1>
            </Column>
          </Grid>
          <Grid>
            <Column lg={16} md={8} sm={4} className="alarm-page__r1">
              <Tile style={{marginBottom: '2rem'}}>
                <h4 style={{marginBottom: '1rem'}}>Dati cliente</h4>
                <table className="alarm-page__table">
                  <tbody>
                  <tr>
                    <td>Nome cliente</td>
                    <td>{alarm.customerName}</td>
                  </tr>
                  <tr>
                    <td>Codice cliente</td>
                    <td>{alarm.customerCode}</td>
                  </tr>
                  <tr>
                    <td>Servizio H24</td>
                    <td>{alarm.serviceH24 ? "Si" : "No"}</td>
                  </tr>
                  <tr>
                    <td>Email sistema</td>
                    <td>{alarm.customerSystemEmail}</td>
                  </tr>
                  </tbody>
                </table>
              </Tile>
              <Tile style={{marginBottom: '2rem'}}>
                <h4 style={{marginBottom: '1rem'}}>Dati allarme</h4>
                <table className="alarm-page__table">
                  <tbody>
                  <tr>
                    <td>Codice allarme</td>
                    <td>{alarm.code}</td>
                  </tr>
                  <tr>
                    <td>Nome allarme</td>
                    <td>{alarm.name}</td>
                  </tr>
                  <tr>
                    <td>Stato allarme</td>
                    <td>{alarm.status}</td>
                  </tr>
                  <tr>
                    <td>Priorità</td>
                    <td>{alarm.severity}</td>
                  </tr>
                  <tr>
                    <td>Tipo sistema</td>
                    <td>{alarm.systemType}</td>
                  </tr>
                  <tr>
                    <td>Codice strumento</td>
                    <td>{alarm.instrumentCode}</td>
                  </tr>
                  <tr>
                    <td>Nome strumento</td>
                    <td>{alarm.instrumentName}</td>
                  </tr>
                  <tr>
                    <td>Data di apertura</td>
                    <td>{alarm.openedAt}</td>
                  </tr>
                  <tr>
                    <td>Data di chiusura</td>
                    <td>{alarm.closedAt ? alarm.closedAt : "n/a"}</td>
                  </tr>
                  <tr>
                    <td>Titolare</td>
                    <td>{alarm.ownerUsername ? alarm.ownerUsername : "Nessuno"}</td>
                  </tr>
                  <tr>
                    <td>Note</td>
                    <td>{alarm.notes ? alarm.notes : "Non è stata inserita alcuna nota."}</td>
                  </tr>
                  <tr>
                    <td>Inoltrato ad assistenza</td>
                    <td>{alarm.forwardedToSupport ? "Si" : "No"}</td>
                  </tr>
                  <tr>
                    <td>Oggetto mail apertura</td>
                    <td>{alarm.shortDesc}</td>
                  </tr>
                  <tr>
                    <td>Contenuto mail apertura</td>
                    <td>
                      <CodeSnippet type="multi" feedback="Testo copiato"
                                   showMoreText="Mostra di più" showLessText="Mostra di meno"
                                   minCollapsedNumberOfRows={3} maxCollapsedNumberOfRows={5}>
                        {parse(alarm.longDesc.replace(/\n/g, "<br />"))}
                      </CodeSnippet>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </Tile>
              <Tile style={{marginBottom: '2rem'}}>
                <h4 style={{marginBottom: '1rem'}}>Eventi allarme</h4>
                <AlarmEventsTable alarmId={alarmID}/>
              </Tile>
              {
                alarm.status === "Aperto" &&
                <Tile style={{marginBottom: '2rem'}}>
                  <h4 style={{marginBottom: '1rem'}}>Azioni allarme</h4>
                  <Grid className="alarm-page__btn-set">
                    <Column lg={16} md={8} sm={8}>
                      <Button onClick={() => {
                        setEditAlarmNoteModalOpen(true)
                        setEditAlarmNoteModalNotes(alarm.notes)
                        setSelectedAlarm(alarm)
                      }}>Modifica note</Button>
                      <Button onClick={() => {
                        handleTakeOwnership(alarmID)
                      }}>Prendi in carico</Button>
                      <Button onClick={() => {
                        setEditAlarmPriorityModalOpen(true)
                        setEditAlarmPriorityModalPriority(alarm.severity)
                        setSelectedAlarm(alarm)
                      }}>Cambia priorità</Button>
                      <Button kind="secondary" onClick={() => {
                        setReportToUserModalOpenState(true)
                        setSelectedAlarm(alarm)
                      }}>Notifica utente</Button>
                      <Button kind="secondary" onClick={() => {
                        setForwardAlarms([alarm.id])
                        setForwardToSupportAlarmModalOpen(true)
                      }}>Inoltra ad assistenza</Button>
                      <Button kind="danger" onClick={() => {
                        setForceCloseAlarmsModalOpen(true)
                        setForceCloseAlarmsModalIdsState([alarmID])
                      }}>Forza chiusura</Button>
                    </Column>
                  </Grid>
                </Tile>
              }
            </Column>
          </Grid>
        </Column>
      </Grid>
    </>
  )
}

export default Alarm
